import axios from '../../../axios';
import { IFileInfoDTO } from '../../awsS3Service';
import { ColumnSettingsDTO } from '../types/ColumnSettingsDTO';
import IClientInvoice from '../types/IClientInvoice';
import { InvoiceFiltersDTO } from '../types/InvoiceFiltersDTO';

const url = '/invoicingservice/api/client-invoicing';

const columnSettingsUrl = '/invoicingservice/api/column-settings';

export const getInvoiceList = (dto: InvoiceFiltersDTO) => axios.post(`${url}/list`, dto);

export const getInvoicesByCandidateId = (candidateId: string, placementType = 'PERMANENT') =>
  axios.get(url, { params: { candidateId, placementType } });

export const getInvoiceAllList = () => axios.get(`${url}/getInvoiceList`);

export const getPresignedURLForPutInvoicePDF = (fileInfo: IFileInfoDTO, invoiceId?: string) =>
  axios.post(url + '/presigned-url-for-put', fileInfo, { params: { invoiceId } });

export const getPresignedURLForPreview = (fileInfo: IFileInfoDTO) =>
  axios.post(url + '/presigned-url-for-preview', fileInfo);

export const getInvoiceCandidateList = () => axios.get(`${url}/invoiceClousrelist`);

export const saveColumnSettings = (dto: ColumnSettingsDTO) =>
  axios.post(`${columnSettingsUrl}/save`, dto);

export const getColumnSettings = (tableKey: string) =>
  axios.get(`${columnSettingsUrl}/fetch/${tableKey}`);

export const getFormstackPdf = (invoice: IClientInvoice) =>
  axios.post(`${url}/formstack-pdf`, invoice, { responseType: 'blob' });
